import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const NOTES_NOTE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/notes',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:Notes',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.Notes',
      },
    ]);
  };
}
